import React from "react";
import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function CertificateOnboardingHeader({
  isTenantAdmin = false,
  tenantCode = "",
  onBack,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBack) {
      onBack();
      return;
    }
    if (isTenantAdmin && tenantCode) {
      navigate(`/issuer/tenant/${tenantCode}/organisations/users`);
      return;
    }
    navigate("/issuer/tenant");
  };

  const handleBackKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleBackClick();
    }
  };

  const breadcrumbLabel = isTenantAdmin
    ? t("tenant:admin_management")
    : t("tenant:tenant_management");

  return (
    <div className="w-full bg-cfSearchContainer flex justify-center py-[0.1rem] px-4">
      <div className="flex flex-col sm:flex-row items-center h-[4rem] sm:items-center justify-between w-full">
        <div className="flex items-center gap-2 text-cfHeadingText font-semibold text-lg self-start my-auto">
          <h2 className="text-lg font-medium flex items-center justify-center h-[4rem] w-full">
            <nav
              className="flex items-center gap-2 text-sm text-cfTextBreadcrumbDisabled"
              aria-label="Breadcrumb"
            >
              <button
                type="button"
                id="cert-onboarding-breadcrumb-tenant"
                onClick={handleBackClick}
                onKeyDown={handleBackKeyDown}
                className="hover:text-cfHeadingText cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-cfPrimary rounded-sm"
              >
                {breadcrumbLabel}
              </button>
              <ChevronRight className="h-4 w-4 text-cfTextBreadcrumbDisabled shrink-0" />
              <span className="text-cfTextBreadcrumbActive font-medium">
                {t("certificateOnboarding:page_title")}
              </span>
            </nav>
          </h2>
        </div>
      </div>
    </div>
  );
}

export default CertificateOnboardingHeader;
